import {Component, forwardRef, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {SocialNetwork} from "../../../../models/SocialNetwork";

@Component({
  selector: 'app-social-network-list',
  templateUrl: './social-network-list.component.html',
  styleUrls: ['./social-network-list.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SocialNetworkListComponent),
      multi: true
    }
  ]
})
export class SocialNetworkListComponent implements OnInit, ControlValueAccessor {

  value: SocialNetwork[] = [];
  urlToAdd: string;
  networkToAdd: string = 'fa-lg fa-brands fa-instagram';
  changeValue: any;

  constructor() { }

  ngOnInit(): void {
  }

  registerOnChange(fn: any): void {
    this.changeValue = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(obj: any): void {
    if(obj){
      this.value = obj;
    }
  }

  add(){

    this.value.push({
      network: this.networkToAdd,
      url: this.urlToAdd
    })
    this.changeValue(this.value);


  }

  remove(index: number){

    this.value.splice(index,1);
    this.changeValue(this.value);

  }

}
